import { gql } from '@apollo/client';

/**
 * 地址生命周期查询：MySQL 当前态 + ClickHouse 变更时间线（旧→新，上限500）。
 * timelineAvailable=false 表示时间线数据源暂不可用（页面降级为仅展示当前状态）。
 */
export const GET_ADDRESS_LIFECYCLE = gql`
  query GetAddressLifecycle($addressCoreId: Long!) {
    addressLifecycle(addressCoreId: $addressCoreId) {
      addressCore {
        id
        fullStandardAddress
        addressType
        zipcode
        latitude
        longitude
        lnglatSource
        plus4Code
        unitType
        unitNumber
        createdAt
        updatedAt
      }
      timelineAvailable
      totalChanges
      firstChangeAtMs
      lastChangeAtMs
      entries {
        changeId
        changeType
        changedAtMs
        sourceSystem
        changeScene
        provider
        batchId
        operator
        traceId
        changedTable
        changedRowId
        changedFields
        before
        after
        rawInput
        providerRaw
      }
    }
  }
`;

/** 全局最近变更列表（生命周期 Tab 默认视图，近 7 天窗口，新→旧）。 */
export const GET_ADDRESS_LIFECYCLE_RECENT = gql`
  query GetAddressLifecycleRecent($limit: Int) {
    addressLifecycleRecent(limit: $limit) {
      changeId
      recordId
      changeType
      changedAtMs
      sourceSystem
      changeScene
      provider
      operator
      batchId
      changedTable
      changedRowId
      changedFields
      fullStandardAddress
    }
  }
`;

/** 近 N 天（默认30，上限93）每日 × 来源 × 场景 × 类型 变更量统计。 */
export const GET_ADDRESS_LIFECYCLE_DAILY_STATS = gql`
  query GetAddressLifecycleDailyStats($days: Int) {
    addressLifecycleDailyStats(days: $days) {
      date
      sourceSystem
      changeScene
      changeType
      count
    }
  }
`;

export interface LifecycleEntry {
  changeId: string;
  changeType: string;
  changedAtMs: number;
  sourceSystem: string;
  changeScene: string;
  provider: string | null;
  batchId: string | null;
  operator: string | null;
  traceId: string | null;
  changedTable: string;
  changedRowId: number;
  changedFields: string[];
  before: string | null;
  after: string | null;
  rawInput: string | null;
  providerRaw: string | null;
}

export interface LifecycleAddressCore {
  id: number;
  fullStandardAddress: string;
  addressType: string;
  zipcode: string;
  latitude: string | null;
  longitude: string | null;
  lnglatSource: string | null;
  plus4Code: string | null;
  unitType: string | null;
  unitNumber: string | null;
  createdAt: string | null;
  updatedAt: string | null;
}

export interface AddressLifecycleView {
  addressCore: LifecycleAddressCore | null;
  timelineAvailable: boolean;
  totalChanges: number;
  firstChangeAtMs: number | null;
  lastChangeAtMs: number | null;
  entries: LifecycleEntry[];
}

export interface GetAddressLifecycleResponse {
  addressLifecycle: AddressLifecycleView;
}

export interface LifecycleRecentEntry {
  changeId: string;
  recordId: number;
  changeType: string;
  changedAtMs: number;
  sourceSystem: string;
  changeScene: string;
  provider: string | null;
  operator: string | null;
  batchId: string | null;
  changedTable: string;
  changedRowId: number;
  changedFields: string[];
  /** MySQL 回查富集的标准化地址文本; 回查失败时为 null */
  fullStandardAddress: string | null;
}

export interface GetAddressLifecycleRecentResponse {
  addressLifecycleRecent: LifecycleRecentEntry[] | null;
}

export interface LifecycleDailyStat {
  date: string;
  sourceSystem: string;
  changeScene: string;
  changeType: string;
  count: number;
}

export interface GetAddressLifecycleDailyStatsResponse {
  addressLifecycleDailyStats: LifecycleDailyStat[] | null;
}
